import dynamic from 'next/dynamic';
import { ContactInfoProps } from './ContactInfo.types';

export const ContactInfo = dynamic<{ model: ContactInfoProps }>(() =>
  import('./ContactInfo').then(mod => mod.ContactInfo)
);
